var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1366,
    zoomAndPan: "magnify",
    viewBox: "0 0 1024.5 1307.999939",
    height: 1744,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc00",
    d: "M 997.78125 394.988281 L 997.78125 394.832031 C 933.734375 1.046875 511.890625 4.375 507.609375 4.375 C 506.5625 4.214844 505.5 4.160156 504.441406 4.214844 C 462.589844 4.214844 78.472656 14.679688 16.804688 394.832031 C -2.953125 525.808594 21.359375 659.640625 85.925781 775.296875 C 195.832031 972.128906 338.304688 1148.910156 507.292969 1298.125 C 676.195312 1148.867188 818.609375 972.09375 928.503906 775.296875 C 993.191406 659.738281 1017.5625 525.933594 997.78125 394.988281 Z M 507.292969 700.632812 C 462.753906 700.617188 419.222656 687.394531 382.199219 662.636719 C 345.171875 637.878906 316.324219 602.699219 299.292969 561.546875 C 282.261719 520.390625 277.820312 475.109375 286.523438 431.429688 C 295.230469 387.75 316.691406 347.632812 348.195312 316.152344 C 379.699219 284.671875 419.832031 263.238281 463.515625 254.5625 C 507.203125 245.890625 552.480469 250.363281 593.621094 267.425781 C 634.765625 284.484375 669.925781 313.359375 694.65625 350.398438 C 719.386719 387.441406 732.578125 430.984375 732.5625 475.519531 C 732.460938 535.21875 708.6875 592.441406 666.457031 634.640625 C 624.230469 676.839844 566.992188 700.570312 507.292969 700.632812 Z M 507.292969 700.632812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinYellow);
export default __webpack_public_path__ + "static/media/pin_yellow.7c243f3e8ae40c9cf22cbdea2b95db9f.svg";
export { ForwardRef as ReactComponent };